import { commonParams } from "../endpoint/EndpointParameters";
import { de_GetOrderCommand, se_GetOrderCommand, } from "../protocols/Aws_restJson1";
import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class GetOrderCommand extends $Command.classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("TempeFabricationPublic", "GetOrder", {})
    .n("TempeFabricationPublicClient", "GetOrderCommand").f(void 0, void 0)
    .ser(se_GetOrderCommand)
    .de(de_GetOrderCommand)
    .build() {
}
